import { ApiResponseDTO } from './api-response.dto';

export class ApiResponseObjectDTO<T> extends ApiResponseDTO {

    data: T;
    
}
